<template>
  <div v-if="items.length">
    <div v-for="itemsLength in xsOnly ? 2 : 1" :key="itemsLength">
      <div class="page-home-latest-news">
        <ArticleCard
          v-for="({ id, title, img, category }, i) in xsOnly
            ? items.slice(
                (itemsLength - 1) * Math.round((items.length + 1) / 2),
                itemsLength * Math.round((items.length + 1) / 2)
              )
            : items"
          :key="i"
          :id="id"
          :title="title"
          :img="img"
          :categoryTitle="category.title"
        ></ArticleCard>
      </div>

      <banner-video
        v-if="itemsLength === 1 && xsOnly"
        class="pt-6"
        type="right-b"
      />

      <banner
        v-if="itemsLength === 1 && xsOnly"
        class="pt-3 pb-6"
        type="center-1-b"
      />
    </div>

    <div class="d-flex justify-center mt-8">
      <v-btn
        :to="path"
        color="primary"
        class="rounded-pill text-capitalize px-4"
        depressed
      >
        Mais Notícias
      </v-btn>
    </div>
  </div>
</template>

<script>
import ArticleCard from "@/components/cards/Article.vue";
import BannerVideo from "@/components/cards/BannerVideo.vue";
import Banner from "@/components/cards/Banner.vue";
import { latestNewsCount, carouselFeaturedCount } from "@/config.js";

const _config = {
  mod: "articles",
  path: "/noticias",
};

export default {
  data: () => ({
    path: _config.path,
    items: [],
  }),
  computed: {
    latestNewsCount() {
      const xs = this.$vuetify.breakpoint.xsOnly;
      if (xs) return latestNewsCount.xs;
      else return latestNewsCount.desktop;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest(_config.mod)
      .get({
        params: { itemsPerPage: this.latestNewsCount + carouselFeaturedCount },
      })
      .then((data) => {
        const items = [];
        const featureds = [];

        for (let item of data) {
          if (
            item.highlight === 1 &&
            featureds.length < carouselFeaturedCount
          ) {
            featureds.push(item);
          } else {
            items.push(item);
          }

          if (items.length === this.latestNewsCount) break;
        }

        this.items = items;
      });
  },
  components: {
    ArticleCard,
    BannerVideo,
    Banner,
  },
};
</script>

<style>
.page-home-latest-news {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

@media screen and (max-width: 960px) {
  .page-home-latest-news {
    gap: 12px;
  }
}
@media screen and (max-width: 600px) {
  .page-home-latest-news {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
